import { render, staticRenderFns } from "./personnalDetailsForm.vue?vue&type=template&id=78b4c050&scoped=true&"
import script from "./personnalDetailsForm.vue?vue&type=script&lang=js&"
export * from "./personnalDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b4c050",
  null
  
)

export default component.exports